export interface NavbarItem {
  name?: string,
  route?: string,
  icon: string
}

export const ICONS = {
  BARCHART: 'fa-bar-chart',
  LINECHART: 'fa-line-chart',
  HOME: 'fa-home',
  CLIPBOARD: 'fa-clipboard',
  BOOK: 'fa-book',
  NOTEPAD: 'fa-calendar-o',
  GRID: 'fa fa-th',
  HELP: 'fa-question-circle',
  COG: 'fa-cog',
  BELL: 'fa-bell',
  USER: 'fa-user'
};



// WEBPACK FOOTER //
// ./src/app/shared/components/layout/NavbarItem.ts